export const EnglishLocal = {
    "translation": {
        "LOAD_USER_INFO": "validating data",
        "ACCESS_DIR": "Recent Accesses",
        "RES_INFO": "Resource Information",
        "AUDIT_INFO": "audit status",
        "AUDIT_DOCS": "Document audit",
        "AUDIT_INFO_SHORT": "Audit Info",
        "AUDIT_INFO_LONG": "Audit Information",
        "CONT": "Contractor",
        "APPROVEDS": "Approved",
        "APPROVED": "Approved",
        "REJECTED": "Rejected",
        "REJECTEDS": "Rejected",
        "PDG_EVAL": "In evaluation",
        "AUDIT_DOC": "Document audit",
        "DOC": "Document",
        "DOCS_CONT": "Contractor Documents",
        "DOCS_EMPS": "Employee documents",
        "DOCS_VEHS": "Vehicle documents",
        "DOCS": "Documents",
        "SBT_QUOT": "Submit Fees",
        "SBT_WHIT_PP": "Partial presentation",
        "SBT_WHIT_PP_CRITERION": "The calculation of partial presentations considers the maximum number of active payment plans configured",
        "DATE": "Date",
        "STATE_DOCTION": "Document status",
        "STATE_RESS": "Resource status",
        "STATE_RES_ENTRY": "Resource Status for Entry",
        "DOC_DUE_BY_CRITERION": "Documentation owed by criteria",
        "DOCTION": "Documentation",
        "DOC_REQ": "Required documentation",
        "EMP": "Employee",
        "EMPS": "Employees",
        "VEH": "Vehicle",
        "VEHS": "Vehicles",
        "CONTRACT": "Contract",
        "CONTRACTS": "Contracts",
        "CONTRACTS_MENU": "Contracts",
        "RPT_SUB_HIS": "Submission history",
        "RPT_SUB_STS": "Submission status",
        "DOC_SUB": "Documents submission",
        "MCONT": "Contractors",
        "MCONT_RES_STS": "Resource status",
        "SCONT_SUB_STS": "Submission status",
        "FILTERS": "Filters",
        "SCH_FILT": "Filter",
        "FILT_FOR": "Filter by",
        "REQ_DOC": "Required Documentation",
        "SEARCH_FILTER": "Search by filters...",
        "REG_NUM": "Number of records",
        "COPY": "Copy",
        "COPIED": "Copied",
        "DOWNLOAD_PAGE": "Download page",
        "DOWNLOAD_ALL": "Download all",
        "DOWNLOAD": "Download",
        "CRITERION": "Criterion",
        "CRITERION_DESCRIP": "Criterion detail",
        "DOC_COD": "Document code",
        "DOC_NAME": "Document name",
        "DOC_PROX_EXRE": "Coming due documents",
        "SEARCH_VEH": "Search Vehicle",
        "SEARCH_EMP": "Search Employee",
        "SEARCH": "Search",
        "INFO_RES": "Resource information",
        "AUDIT_RESS": "Resource audit",
        "RES": "Resource",
        "RESS": "Resources",
        "TPE_RES": "Resource type",
        "ID": "ID",
        "PATENT": "Plate",
        "ID_PATENT": "ID/Plate",
        "NAME": "Name",
        "BND_MOD": "Brand/Model",
        "NAME_BND_MOD": "Name/ Brand/ Model",
        "STION_RES": "Resource status",
        "STION": "Situation",
        "STE_CURR_DATE": "Status to date",
        "STE_APTDE": "Aptitude",
        "EXRE": "Expiration",
        "PNT_DOC": "Submit document",
        "STATE": "State",
        "CONTRACTS_STATUS": "Contract status",
        "EMP_PHOLDER_ENTRY": "Search by ID or name",
        "VEH_PHOLDER_ENTRY": "Search by Plate or Name",
        "APT_ENTRY": "Suitable",
        "UN_APT_ENTRY": "Not Suitable",
        "STFING": "Satisfactory",
        "UN_STFING": "Not satisfactory",
        "CUIL": "Cuil",
        "RBO": "Business Activity",
        "RANK": "Classifications",
        "ACTIVE": "Active",
        "INACTIVE": "Idle",
        "LOW": "Discharged",
        "LASTS": "Last",
        "DAYS": "Days",
        "OPENING": "Opening",
        "ENTRY": "Entry",
        "CHANGE": "Modify",
        "APT": "Suitable",
        "PART_APT": "Partially Suitable",
        "UN_APT": "Not Suitable",
        "PENDING_CLOSE": "Pending Closure",
        "VALTY": "Habilitation Validity",
        "VALIDITY": "Habilitation Validity",
        "EXIT": "Leave",
        "SUBMITED": "Submitted",
        "PDING": "Due",
        "PDING_OP": "Due (Expired and not submitted)",
        "NOT_SUBMITED": "Not submitted",
        "EXPIRED": "Expired",
        "CREDENTIAL": "Credential",
        "APPLY": "Apply",
        "SHOW_MORE": "Show more",
        "NO_DATA": "There is no data to show",
        "YES": "Yes",
        "NO": "No",
        "DEPNDS_REL": "Under employment contract",
        "SUB_CONTRACT": "Self-Employed",
        "CONCEPT": "Concept",
        "OTHER": "Other",
        "UP_DATE": "Sign In date",
        "TYPE_CONTRACT": "Contracting condition",
        "IS_DRIVER": "Drives",
        "CODE": "Code",
        "DESCRIPTION": "Description",
        "CONCEPT_DESCRIP": "Concept description",
        "DATE_SINCE": "From date",
        "DATE_UNTIL": "To date",
        "DATE_PRESENT": "Submission date",
        "DATE_AUDIT": "Audit date",
        "CORRESPONDING_TO": "Corresponding to ",
        "EVENTUALITY": "Cotingency",
        "VALUE": "Value",
        "MORE_INFO": "More information",
        "EXCEPTION_UNTIL": "You can enter up to ",
        "STATUS_TO_ENTRY": "resource status",
        "SEND_TO": "Send all",
        "SEND": "Send",
        "LAST_ONE_DAYS": "Last 24 hours",
        "LAST_SEVEN_DAYS": "Last 7 days",
        "LAST_SEVENTEEN_DAYS": "Last 15 days",
        "LAST_THRITY_DAYS": "Last 30 days",
        "SELECT": "Select",
        "HELLO": "Hi!",
        "FILTER_DOCS": "Document Filters",
        "FILTER_RES": "Resource Filters",
        "NO_DATA_SEARCH": "There are no search results.",
        "SHOW_ALL": "Show all",
        "ERROR_PAGE_TITTLE": "Error, page not found",
        "ERROR_TENANT_TITTLE": "Error, the instance is not configured",
        "ERROR_PAGE_MESSAGE": "Sorry, the requested page was not found. Please contact the administrator.",
        "ERROR_TENANT_MESSAGE": "Please contact Exactian.",
        "ERROR_PAGE_GO_TO": "Back to top",
        "ERROR_TENANT_GO_TO": "Go to Exactian",
        "NO_DOCUMENTS_LEFT": "No documentation due",
        "NO_DATA_PERIOD_LEFT": "No information to show for the selected period",
        "ERASE": "Delete",
        "FIRSTWORD_MSG_LOAD_DOCS_STATUS": "Press",
        "FIRST_KEY_WORD_LOAD_DOCS_STATUS": "Load information",
        "SECONDWORD_MSG_LOAD_DOCS_STATUS": "To view this graphic or",
        "SECOND_KEY_WORD_LOAD_DOCS_STATUS": "General detail",
        "THIRDWORD_MSG_LOAD_DOC_STATUS": "To see more information.",
        "MSG_NOT_TO_GO": "* When loading begins do not exit the screen.",
        "PAST_DUE_HISTORY": "Owed Documentation",
        "ALL_APTITUDES": "All situations",
        "ALL_AUDITS": "All the states",
        "ALL_CONTRACTS": "All contracts",
        "ALL_CRITERION": "All criteria",
        "ALL_DOCS": "All documents",
        "ALL_EMP": "All employees",
        "ALL_VEH": "All Vehicles",
        "ALL_OPENINGS": "All Types of Business Activities",
        "ALL_EVENTIUALITIES": "All contingencies",
        "ALL_RESOURCES": "All resources",
        "ALL_CLASSIFICATION": "All classifications",
        "HISTORY": "Record",
        "FROM": "From",
        "UNTIL": "To",
        "PERIOD": "Period",
        "SUBMIT_DOC": "Submit document",
        "AUDITOR": "Auditor",
        "SHOW_DETAIL": "View detail",
        "GLOBAL_PRESENTATION": "Global Submission",
        "INDVIDUAL_PRESENTATION": "Single Submission",
        "ATTACH": "Attach",
        "DELETE": "Delete",
        "SHOW_FILE": "View file",
        "CANCEL": "Cancel",
        "DATE_RANGE": "Date range",
        "SITUATION_HISTORY": "Status History",
        "ACCEPT": "Accept",
        "LOAD_FILE": "File loaded",
        "SELECT_TWO": "Select",
        "OR_DRAG": "or drag a document",
        "ACCEPT_FORMATS": "Compatible formats",
        "MAX_SIZE": "Maximum size",
        "MAX_SIZE_ERROR": "File size larger than",
        "ACCEPT_FORMATS_ERROR": "Invalid File Format",
        "IN_EVALUATION_FROM": "In evaluation from",
        "SELECT_TYPERES_O_DOC": "You must select Type of resource or Document",
        "NO_INSTRUCTIONS": "No Instructions",
        "SERVER_ERROR": "Server error",
        "REPEAT_SUBMIT_ERROR": "A submission was already made for the document/resource/period",
        "ERROR_SUBMIT_TITTLE": "Error uploading document",
        "ERROR_SUBMIT_SERVER": "There was a problem at uploading the document",
        "SUCCESS_SUBMIT_TITTLE": "Done!",
        "SUCCESS_SUBMIT_MESSAGE": "The document was submitted successfully. You will soon receive a response from the auditor.",
        "WARNING": "Caution",
        "REPLACE_WARNING": "It already exists a submission that matches those dates. Do you wish to replace it?",
        "PRESET_DATE_INFO": "Date set automatically, it can be modified",
        "DELETE_NEXT_DOC": "You are about to delete the following document:",
        "SURE_TO_CONTINUE": "Do you wish to continue?",
        "NO_DOC_DUE": "No documentation due",
        "DOC_DUE_NUM_PART_ONE": "Documentation owed, in the last",
        "DOC_DUE_NUM_PART_TWO": "months. Review history",
        "GLOBAL_DOC_UPLOAD": "Documents Global submission",
        "UPLOAD_FILE": "Upload file",
        "CONTINUE": "Continue",
        "CONFIRM": "Confirm",
        "REPLACE_PRES_IF_HAS_DUP": "Replace presentation in case of duplication.",
        "TITLE_GLOBAL_DOC_STEP1": "Select the type of document you want to submit massively",
        "TITLE_GLOBAL_DOC_STEP2": "Select the resources for which you wish to upload the selected document",
        "FILE_NOT_FOUND": "File not found.",
        "SELECT_ALL": "Select all",
        "TITLE_EXP_IMP_STEP2": "Download or upload the file with the resources",
        "DOWNLOAD_FILE": "Download file",
        "ERROR": "Error",
        "IMPORT_ERROR_RES_TXT": "records that do not match with the list of resources. Only the resources that match will be imported.",
        "FILE_HAVE": "The file contains",
        "EXP_IMP_BTN_STEP2": "Export / Import file",
        "UPLOAD_OTHER_FILE": "Upload another file",
        "WANT_HAVE_SAMPLE_FILE": "Do you wish to have a sample file?",
        "TEXT_EXP_IMP_STEP2": "The sample file includes all the resources to which you can present the selected document.",
        "SELECTED": "Selected",
        "NO_EXPIRATION": "No expiration",
        "RESOURCE_INFO": "Resource detail",
        "EXPORT": "Export",
        "GENERAL_REPORT": "General Report",
        "CONTRACTOR": "Contractor",
        "IMPORT_ERROR_STRUCTURE_TXT": "Please check that your file contains a column named",
        "NOT_EDIT_COL": "IMPORTANT!: Do not edit the name of the columns.",
        "ERROR_IMP": "Import error",
        "ERROR_FORMAT": "Format error",
        "PREVIEW": "Preview",
        "Total": "Total",
        "DRIVE": "Drives",
        "BULK_UPLOAD_DETAIL": "Massive Submission Detail",
        "VALTY_WORD": "Validity",
        "DELETE_PRES": "delete presentation",
        "DELETE_PRES_SUCCESS": "The presentation was successfully deleted!",
        "DELETE_PRES_ERROR": "Could not delete presentation",
        "DELETE_PRES_ERROR_MSG": "There was a problem deleting the file.",
        "OPEN_FILE_IN_NEW_TAB": "The file was opened in a new browser tab.",
        "TOTAL_PRESS": "Total submission",
        "DOC_PERIOD": "Documentation correspondent to",
        "SUCCESS_SUBMIT_MESSAGE_TWO": "The document was successfully submitted.",
        "VALIDITY_DATE": "Validity date",
        "VALIDITY_ERROR_MESSAGE": "The to date must be greater than the from date",
        "USER_NAME": "User",
        "PASSWORD": "Password",
        "HELLO_AGAIN": "Hello again!",
        "RECOVER_PASSWORD": "Reset password",
        "GET_INTO": "Enter",
        "ENTER_USER_NAME": "Enter your username",
        "ENTER_PASSWORD": "Enter your password",
        "ERROR_LOGIN_CREDENTIALS": "Wrong credentials!",
        "ENTER_MAIL": "Enter your Email",
        "CHOOSE_OPENING": "Select one",
        "CHANGE_OPENING": "Change opening",
        "CHANGE_BUILDING": "Change building",
        "ENTER_MAIL_AND_USER_TO_RESET": "Enter your email and username to reset the password",
        "WRONG_USER_ERROR": "The user entered does not exist",
        "INSTANCE_INFO_ERROR": "Instance not found",
        "CHECK_YOUR_MAIL": "Check your email",
        "WE_SEND_A_MAIL_TO": "We have sent you an email to",
        "FOR_RESET_PASSWORD": "so you can reset the password",
        "DID_NOT_ARRIVE_THE_MAIL": "Didn't get the email?",
        "REMEMBER_CHECK_SPAM": "Remember to check the spam folder",
        "RESEND_MAIL": "Resend email",
        "CHANGE_MAIL": "Change email",
        "WAS_SEND": "Sent",
        "WELCOME": "Welcome",
        "NEW_PASSWORD": "New Password",
        "MY_ACCOUNT": "My account",
        "REPORTS": "Reports",
        "CONFIG": "Settings",
        "HELP": "Help",
        "LOGGOUT": "Sign off",
        "SCAN_OR_CODE_DNI": "Place the cell phone in front of the QR or ID code",
        "MANUAL_ENTRY": "Manual entry",
        "WRITE_ID": "Type the identification number or DNI.",
        "PASS_CREATED": "Password successfully generated",
        "ENABLED": "Enabled",
        "NOT_ENABLED": "Not enabled",
        "APT_TO_ENTRY": "Enabled to enter",
        "NOT_APT_TO_ENTRY": "Not enabled to enter",
        "STATUS_DETAIL": "Status detail",
        "SEARCH_CODE_OR_SCAN": "Search by ID | Document number or scan QR",
        "MAX_EIGHT_CARACT_ALLOW": "Minimum of 8 characters allowed",
        "TO_USE_CAMERA_NEED_PERMISSIONS": "To use the scanner you need the permissions of the camera",
        "ALLOW_USE": "Allow use",
        "INSTANCE_NOT_CONFIG_TO_ENTRY": "Instance not configured for entries",
        "CREATE_PASS": "Generate password",
        "WRITE_NEW_PASS": "Enter a new password for your account",
        "CONFIRM_PASS": "Confirm Password",
        "MIN_EIGHT_MAX_FIFTY_CARACT": "Minimum 8 characters and maximum 50 characters",
        "UPPERCASE": "Capital letter",
        "LOWERCASE": "Lower case",
        "NUMBER": "Number",
        "EMAIL": "E-mail",
        "VALIDATING": "Validating",
        "SELECT_CONTRACT": "Select a contractor",
        "PERSON_ENTRY_WITH": "The person enters with",
        "SELECT_VEH": "Select vehicle",
        "ENTRY_DETAIL": "Entry detail",
        "WRITE_VISIT_DATA": "Enter the information about the visit",
        "SUCCESS_ACCESS_DESC": "The entry was successfully registered",
        "VISIT": "Visit",
        "VISITS": "visits",
        "HOURS": "Hours",
        "RES_BY_OPENINGS": "Resources for Type of Business Activity",
        "RES_BY_HOURS": "Hourly resources",
        "ADDITIONAL_INFO": "Additional Information",
        "CLASSIFICATION": "Classification",
        "COLOR": "Color",
        "ENGINE_NUMBER": "Engine number",
        "CHASSIS_NUMBER": "Chassis number",
        "ASSIGNED": "assigned",
        "DATE_HOUR_EXIT": "Exit's date and hour",
        "DATE_HOUR_ENTRY": "Admission's date and hour",
        "HOUR": "Hour",
        "SAVE": "Save",
        "EDIT": "Edit",
        "DEPARTURE": "Exit",
        "EXIT_DETAIL": "Exit detail",
        "PERSON_EXIT_WITH": "The person leaves with",
        "SUCCESS_EXIT_DESC": "The exit was successfully registered",
        "TOKEN_ERROR": "Session ended",
        "ACCESS_WITH_CAR": "The person enters with his own vehicle or a company's one.",
        "EXIT_WITH_CAR": "The person leaves with his own vehicle or a company's one.",
        "NEXT": "Next",
        "GET_BACK": "Return",
        "CONT_MAIN": "Main contractor",
        "SCAN_QR_OR_ID": "Scan QR or ID",
        "NO_CAR": "Without vehicle",
        "NO_CAR_ACCESS": "The person enters without vehicle",
        "NO_CAR_EXIT": "The person leaves without vehicle",
        "OBSERVATIONS": "Observations",
        "DENY": "Deny",
        "SCAN_ERROR": "Invalid scanned code",
        "RES_BY": "Resources by",
        "RES_OF": "Resources of",
        "STATUS_ERROR_ACCESS": "The employee or vehicle selected cannot be entered due to it's status",
        "STATUS_ERROR_ACCESS_VISIT": "The visit cannot be entered due to its status",
        "CONCURRENCY_ERROR_ACCESS": "The employee or vehicle selected is already admitted",
        "CONCURRENCY_ERROR_EXIT": "The employee or vehicle that you're trying to exit was not admitted",
        "CONCURRENCY_ERROR_ACCESS_VISIT": "The visit you are trying to admit is already registered",
        "CONCURRENCY_ERROR_EXIT_VISIT": "The visit that you're trying to exit was not admitted",
        "PARAM_MISSMATCH": "The visit corresponds to an active or not suitable discharged employee",
        "VISIT_REASON": "Motive for visit",
        "EMPLOYEE_NO_ACCESS_ERROR": "The employee is not authorized to enter",
        "FINISH": "Finish",
        "VEHICLE_DATA_NO_CONFIRM": "There is information regarding a vehicle unconfirmed.",
        "DO_YOU_WANT_TO_ADD": "Do you want to add it?",
        "ADD": "Add",
        "VEHICLE_DATA_NO_COMPLETED": "You entered incomplete information of the new vehicle.",
        "DO_YOU_WANT_TO_COMPLETE": "Do you want to complete the information?",
        "COMPLETE": "Complete",
        "FULL_NAME": "Full name",
        "ENTER_FULL_NAME_OF_VISIT": "Enter visit's full name",
        "ENTER_VISIT_REASON": "Enter the visit's motive",
        "ENTITY_MAG_DESC": "Description of this type of reports",
        "PARAMS": "Parameters",
        "MANDATORY_INFO": "Mandatory information",
        "QR_CODE_SCANNER": "QR/ID code scanner",
        "QR_CODE_ACTIVE_DESC": "If it is active, the scanner can be used.",
        "VISIT_ACTIVE_DESC": "Employees on leave/inactive with documentation owed can enter as visitors.",
        "PREFERENCES": "Preferences",
        "OPENING_ACTIVE_DESC": "If it is active, it is mandatory to select a type of business activity once logged in.",
        "ENTITY_MANAGEMENT": "Entities management",
        "OPENINGS": "Types of Business Activity",
        "ENABLE_OPENINGS": "Enable types of business activity in the app.",
        "SEARCH_OPENNINGS": "Search types of business activity",
        "ENTRY_DEPARTURE": "Entry / Exit",
        "PERMANENCE": "Permanence",
        "TODAY": "Today",
        "ALL": "All",
        "TYPES": "Types",
        "PERMISSIONS_ERROR": "You do not have permissions, speak to the Administrator.",
        "UNDERSTOOD": "Understood",
        "RESOURCES_IN_OPENING_ERROR": "This type of business activity cannot be disabled since it has entries registered.",
        "RESOURCES_IN_WITHOUT_OPENING_ERROR": "Error, there are resources entered without type of business activity.",
        "ENTITY_CONFIG": "Entity settings",
        "PARAMS_CONFIG": "Parameters settings",
        "DATA_BASICS_CONFIG": "Basic data settings",
        "PREFERENCES_CONFIG": "Preferences settings",
        "NO_OPENING": "No Type of business activity",
        "PERMANENCE_TIME": "Time spent",
        "WRITE_VISIT_VEHICLE_DATA": "Enter vehicle data",
        "RES_NAME": "Resource name",
        "TYPE": "Type",
        "CONTRACTOR_CUIT": "Contractor's cuit",
        "MOVEMENTS": "Movements",
        "TIME_ELAPSED": "Time elapsed",
        "BUILDING": "Building",
        "AREA": "Area",
        "MINUTES": "Minutes",
        "PLANT_RESOURCES": "Resources in Plant",
        "DOWNLOAD_REPORT": "Download report",
        "EMP_DETAIL": "Employee detail",
        "ENTER_VEHICLE_VISIT_PATENT": "Enter plate number",
        "ENTER_VEHICLE_VISIT_MODEL": "Enter model",
        "ENTER_OBSERVATIONS": "Enter observations",
        "REPORT": "Report",
        "VEH_DETAIL": "Vehicle detail",
        "VIS_DETAIL": "Detail of the visit",
        "DETAIL": "Detail",
        "MOV_DETAIL": "Detail of movements",
        "MINUTE": "Minute",
        "RES_PERMANENCE_DETAIL": "Resource permanence detail",
        "EMPLOYEE_NO_ACCESS_OPENING_ERROR": "The resource does not belong to the type of business activity selected",
        "LINK_EXPIRED": "The link expired",
        "EXCEPTED": "Excepted",
        "RES_ENTERED": "Resources admitted",
        "PAGE": "Page",
        "OF": "of",
        "NORMAL_HS": "Normal hours",
        "50%_HS": "Extra hours 50%",
        "100%_HS": "Extra hours 100%",
        "NORMAL_HS_SHORT": "Normal hs",
        "50%_HS_SHORT": "Extra hs 50%",
        "100%_HS_SHORT": "Extra hs 100%",
        "RESOURCE_DATA": "Resource Data",
        "USER_ACCESS": "User access",
        "USER_EXIT": "User exit",
        "TOTAL_HS": "Total hours",
        "TOTAL_HS_PER": "Total hours per",
        "RECORDS": "Records",
        "BY": "By",
        "ERROR_TRY_AGAIN": "An error occurred, please try again.",
        "NOT_ENABLE_OPENING_WITHOUT_OPNING": "You cannot enable it since you have resources admitted without a ",
        "ASSIGNED2": "assigned",
        "REQUESTS": "Queries",
        "ERROR_DATA_ENTER": "An error occurred, please check the data entered",
        "DOWNLOAD_APP": "Install Web App",
        "EMPLOYEE_HAVE_FUTURE_INCOME_ERROR": "The queried ID corresponds to an employee whose date of joining Exactian is in the future",
        "AUTHORIZED_BY": "Approved by",
        "CHOOSE_CAMERA": "Select a camera to scan",
        "NAME_OF_ENTITIES": "Name of entities",
        "CONF_NAME_OF_ENTITIES": "Entity Name Settings",
        "CREATE": "Create",
        "ENTER_DESCRIPTION": "Enter a description",
        "RESOURCES_IN_BUILDING_ERROR": `You cannot disable those who have registered entries.`,
        "CREATED_SUCCESSFULLY": "created successfully",
        "EDITED_SUCCESSFULLY": "edited successfully",
        "DELETED_SUCCESSFULLY": "deleted successfully",
        "ARE_YOU_SURE_DELETE": "Are you sure you want to delete",
        "CHOOSE_BUILD": "Select a",
        "NO_BUILDING": "No Building",
        "THE_RESOURCE_IS_ALREADY_IN": "The resource is already entered in the",
        "NO_ASSIGNMENT": "No assignment",
        "CODE_ALREADY_EXIST": "The code already exists, please change the code.",
        "RESOURCES_IN_BUILDING_ERROR_TO_DELETE": `It cannot be deleted as it has recorded income.`,
        "NOT_ACCESS_OPENING": `does not exist or is disabled.`,
        "BUILDINGS_IN_OPENING": `The action cannot be carried out because it is assigned`,
        "THERE_ARE": `There are`,
        "WITHOUT": `without`,
        "ASSOCIATED": `associated`,
        "CANT_DELETE_FOR_ENTRYS": `It cannot be deleted as it has recorded income.`,
        "CANT_ENABLE_FOR_ENTRYS": `It cannot be disabled since it has registered income.`,
        "CANT_DELETE_FOR_ASSIGNED_TO_USER": `It cannot be deleted since the entity is assigned to a user.`,
        "CANT_DELETE_BUILDING_HAS_AREAS_ERROR": `It cannot be deleted since it has assigned areas.`,
        "FREE_ACCESS_AREA": "Free Access",
        "ACCESS_ONLY_TO": "Access only to",
        "SELECT_PERSON_TO_VISIT": "Select person to visit",
        "PERSON_VISITED": "Person visited",
        "SURNAME": "Surname",
        "PERSON_TO_VISIT": "People to visit",
        "CONFIG_PERSON_TO_VISIT": "Configuration of People to visit",
        "SECTORS": "Sectors",
        "CONFIG_SECTOR": "Configuration of sectors",
        "SECTOR": "Sector",
        "AMOUNT_PEOPLE_ALLOWED": "Number of people allowed",
        "ALLOW_PEOPLE_TO_VISIT": "Enable people to visit as mandatory data",
        "NOT_EXIST_SECTOR_ERROR": "The sector does not exist or is disabled",
        "NAME_ALREADY_EXIST": "The name already exists, please change the name",
        "DNI_ID_ALREADY_EXIST": "he DNI/ID already exists, please change the DNI/ID",
        "OPENING_HAS_BUILDINGS_ERROR_SELECTED": "You selected an opening that has buildings. Please select the building.",
        "RESOURCE_IN_VISITED_ERROR": "The person cannot be disabled because they are being visited.",
        "PERSON_VISITED_ERROR": "The person cannot be deleted because it has already been visited.",
        "SECTOR_USED_ERROR": "The sector cannot be disabled or deleted because it is in use.",
        "CANT_DELETE_BUILDING_HAS_PERSON_ERROR": `It cannot be deleted since it has assigned people to visit.`,
        "WITHOUT_SECTOR": `No sector`,
        "OPENING_WITH_PERSON_ASIGNED_ERROR": `It cannot be disabled because it has an assigned person to visit.`,
        "NOT_ACCESS_OPENING_START": "The entry could not be completed, because it was logged in without",
        "NOT_ACCESS_OPENING_START_MID": ", and there are",
        "NOT_ACCESS_OPENING_MID": "entry enabled. Please re-log in to a specific entry",
        "NOT_ACCESS_OPENING_END": "to be able to make entries/exits.",
        "BUILDINGS_WITHOUT_OPENING_START": "The entry could not be completed, because you were logged in without",
        "BUILDINGS_WITHOUT_OPENING_START_MID": ", and there are",
        "BUILDINGS_WITHOUT_OPENING_MID": "enabled. Please log in again to a specific",
        "BUILDINGS_WITHOUT_OPENING_END": "to be able to make entries/exits.",
        "NOT_ENABLE_BUILDING_WITHOUT_BUILDING": "You cannot enable it since you have resources entered without a ",
        "MANDATORY_PEOPLE_TO_VISIT_ERROR": 'Please configure at least one "person to visit"',
        "MAXIMUM_PEOPLE_TO_VISIT_ERROR": "The number of people selected exceeds the allowed quota",
        "EQUIPMENT_OR_TOOLS": "Equipment or tools",
        "THE_PERSON_ACCESS_WITH_EQUIPMENT_OR_TOOLS": "The person enters with equipment or tools.",
        "SELECT_WITH_EQUIPMENT_OR_TOOLS": "Select equipment or tool",
        "EQUIPMENT_OR_TOOLS_SELECTABLE": "Equipment/Tools",
        "ADD_INFO_OF_TOOL_OR_EQUIPMENT": "Enter additional information such as the equipment code or model",
        "TYPE_EQUIPMENT_OR_TOOLS": "Type of equipment or tools",
        "TYPE_EQUIPMENT_OR_TOOL_CREATE_SUCCESSFULLY": "Type of equipment or tools created successfully",
        "TYPE_EQUIPMENT_OR_TOOL_EDIT_SUCCESSFULLY": "Type of equipment or tools successfully edited",
        "TYPE_EQUIPMENT_OR_TOOL_DELETED_SUCCESSFULLY": "Type of equipment or tools successfully deleted",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_ALREADY_EXIST": "The name already exists, please change the name.",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DISABLED": "There is a resource entered with no exit that entered with this type of equipment",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DELETE": "Equipment cannot be deleted because it has already been used",
        "CONFIG_EQUIPMENT_OR_TOOLS": "Configure equipment or tool types",
        "EQUIPMENT_DATA_NO_CONFIRM": "There is information about unconfirmed equipment.",
        "EQUIPMENT_DATA_NO_COMPLETED": "You entered incomplete information for a new vehicle.",
        "EQUIPMENT_NOT_EXIST_OR_DISABLED_ERROR": "Selected equipment type does not exist or is disabled",
        "NO_EQUIPMENT": "No equipment",
        "THE_ACCESS_RECORD_WAS_MODIFY_AT_THE_DATE": "The entry date was modified on the day",
        "THE_EXIT_RECORD_WAS_MODIFY_AT_THE_DATE": "The exit date was modified on the day",
        "VIEW_DUE_DOC": "View Due Documentation",
        "DUE_DOC_OF": "Documentation due of",
        "DUE_DOC_OF_THE_RESOURCE": "Due documentation of the resource",
        "CANT_ADD_VEH_WITH_THE_SAME_PATENT": "You cannot add the vehicle because one with the same license plate already exists.",
        "FILTER_MORE_FOR_DOWNLOAD": "Filter more to download report",
        "CANNOT_CREATE_THE": `Cannot create the`,
        "CANNOT_CREATE": `Cannot create the`,
        "BECAUSE_EXISTING_RESOURCES_IN_THE": "because there are resources in the",
        "BECAUSE_EXISTING_RESOURCES_IN": "because there are resources in the",
        "WHITOUT": "Without",
        "CANNOT_ENABLE_THE": `Cannot enable the`,
        "CANNOT_ENABLE": `Cannot enable the`,
        "SHOW_CONTRACTS_DETAILS": `See contract details`,
        "CONTRACTS_DETAILS": `Contract details`,
        "EMP_HAS_NOT_CONTRACTS_ASSIGNED": `The employee is not assigned to any contract`,
        "VEH_HAS_NOT_CONTRACTS_ASSIGNED": `The vehicle is not assigned to any contract`,
        "INVALID_DATE_MODIFICATION": "The date cannot be modified because it would create a conflict with existing movements.",
        "PRIVACY_POLICY": "Privacy Policy",
        "ENTRIES": "Entries",
        "AREA_SELECT": "Select area",
        "MANDATORY_AREA_SELECT": "It is necessary to specify the area and the 'Free access' option will not be available.",
        "EDITED_BY": "Edited by",
        "REASON": "Reason",
        "DATE_SINCE_CANT_BE_MORE_THAN_UNTIL_DATE": "The start date cannot be more than the end date",
        "DATE_RANGE_CANT_BE_MORE_THAN_ONE_YEAR": "The date range cannot be more than 1 year",
        "DATE_RANGE_CANT_BE_FUTURE": "The date range cannot be future",
        "CONSIDER_CONTRACTS_FOR_RESOURCE_APTITUDE":"Consider contracts to define resource aptitude",
        "CONTRACTS_FOR_RESOURCE_APTITUDE_DESC":"When enabling this option, the entry application will consider the status of all the resource's contracts to define if it is fit or unfit to enter.",
        "DUE_DOC_CONTRACTS": "Due documentation of contracts",
        "CONTRACTS_CONSIDERED_FOR_ENTRY": "The contract status is considered for entry.",
        "CONTRACTS_NOT_CONSIDERED_FOR_ENTRY": "The contract status is not considered for entry.",
        "CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_EMP": "The contractor's contract status is considered for entry, even without assignment to the employee.",
        "CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_VEH": "The contractor's contract status is considered for entry, even without assignment to the vehicle.",
        "CONTRACT_DATE_VALIDITY_TOOLTIP": "The date corresponds to the contract validity period",
        "CONTRACT_DATE_RESOURCE_ASSIGNMENT_TOOLTIP": "The date corresponds to the resource assignment to the contract",
    }
}